import React from "react";
import routeGuard from "src/HOC/routeGuard";
import ThrustCalculationList from "src/components/ThrustCalculation/list";
import { RESOURCE_TYPE } from "src/constant/common";

const ThrustCalculation = () => {
  return <ThrustCalculationList />;
};

export default routeGuard(ThrustCalculation, RESOURCE_TYPE.LABOR_SAVING);
